// Types
import { RootState } from 'types/RootState.types';

export const getErrorSelector = (state: RootState) => state.error?.error;
